var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 66.9706C17.4555 66.9706 3.18182 52.7005 3.18182 35.1531C3.18182 17.6074 17.4555 3.33409 35 3.33409C52.543 3.33409 66.8182 17.6074 66.8182 35.1531C66.8182 52.7005 52.543 66.9706 35 66.9706ZM0 35.1531C0 54.4504 15.7007 70.1523 35 70.1523C54.2977 70.1523 70 54.4504 70 35.1531C70 15.8543 54.2977 0.152344 35 0.152344C15.7007 0.152344 0 15.8543 0 35.1531Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 19.4023V51.1659C28 51.1659 37.2194 45.5741 47.9274 35.2841C37.2194 24.9941 28 19.4023 28 19.4023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.143c93d4d982f21a167c9bd4080b5812.svg";
export { ForwardRef as ReactComponent };